<!-- BUTTON ENABLED -->
<div style="display: flex;">
    <button *ngIf="!disabled" type="button" (click)="onTbClick()" class="teia-button {{type}}"
        [ngClass]="{'teia-button-mobile' : isMobile, 'no-width' : noWidth, 'width100': fullWidth}"
        [ngStyle]="{'width: auto !important' : noWidth}">{{text}}</button>

    <!-- BUTTON DISABLED -->
    <button *ngIf="disabled" type="button" class="teia-button tb-disabled"
        [ngClass]="{'teia-button-mobile' : isMobile, 'no-width' : noWidth, 'width100': fullWidth}">{{text}}</button>

    <button *ngIf="secondaryActionIcon" class="secondary-action-button-{{type}}" (click)="onTbSecondaryActionClick()"><i
            [ngClass]="secondaryActionIcon"></i></button>
</div>